export const LangStrings: Record<string, Record<string, string>> = {
  en: {
    "1day": "1 day",
    "1month": "1 month",
    "1week": "1 week",
    "1year": "1 year",
    English: "English",
    French: "French",
    Good: "Good",
    Normal: "Normal",
    OR: "OR",
    Poor: "Poor",
    Strong: "Strong",
    Weak: "Weak",
    accountactivated: "User validated successfully",
    accountvalidation: "To active your account, please click on the link below",
    actions: "Actions",
    activate: "Activate",
    active: "Active",
    active_alerts: "Active",
    add: "Add",
    add_category: "Add category",
    add_channel_description:
      "Add a channel to receive notifications and alerts",
    add_entity_type: "Add entity type",
    add_first_member: "Add Your First Member",
    add_member: "Add Member",
    add_member_description: "Add members to collaborate in your organization",
    add_new_member: "Add New Member",
    addchannel: "Add channel",
    addtrackerstosearchbar: "Add trackers to searchbar",
    admin: "Admin",
    admin_description: "Full access - can create, read, update, and delete",
    advanced_parameters: "Advanced parameters",
    advanced_search: "Advanced Search",
    advancedoptions: "Advanced options",
    aggregation: "Aggregation",
    ago: "ago",
    alert_condition: "Trigger condition",
    alert_description_placeholder: "Describe the purpose of this alert...",
    alert_name: "Alert name",
    alert_name_placeholder: "e.g. Mention spike",
    alert_not_triggered: "Condition not met",
    alert_triggered: "Alert triggered",
    alert_type_anomaly: "Anomaly",
    alert_type_anomaly_desc: "Automatic anomaly detection",
    alert_type_change: "Change",
    alert_type_change_desc: "Trigger on significant variation",
    alert_type_custom: "Custom",
    alert_type_custom_desc: "Custom Elasticsearch query",
    alert_type_new_documents: "New documents",
    alert_type_new_documents_desc: "Trigger when new documents are detected",
    alert_type_threshold: "Threshold",
    alert_type_threshold_desc: "Trigger when a metric exceeds a threshold",
    alertcreated: "Alert created",
    alertdeleted: "Alert deleted",
    alerthistory: "Alert history",
    alerts: "Alerts",
    alerts_description: "Configure alerts to be notified automatically",
    alertupdated: "Alert updated",
    all_status: "All statuses",
    all_types: "All types",
    anomaly_desc: "Alert will automatically detect abnormal behaviors.",
    api_tokens: "API Tokens",
    applyfilters: "Apply filters",
    available_sources: "Available Sources",
    avatars: "Avatars",
    average: "Average",
    back: "Back",
    back_to_search: "Back to search",
    back_to_selection: "Back to selection",
    billing_period: "Billing Period",
    browsers: "Browsers",
    cancel: "Cancel",
    card_view: "Card view",
    card_view_description: "Detailed cards with media",
    change: "Change",
    change_desc: "Alert will trigger on significant change.",
    change_member_role: "Change Member Role",
    change_percentage: "Change percentage (%)",
    change_role: "Change Role",
    change_view: "Change view",
    changepassword: "Change password",
    changepasswordsuccess: "Your password has been successfully changed!",
    channel: "Channel",
    channelcreated: "Channel created",
    channeldeleted: "Channel deleted",
    channels: "Channels",
    channels_desc: "Choose how you want to be notified.",
    check_interval: "Check interval",
    check_interval_desc: "How often should the alert be evaluated?",
    checked: "Checked",
    choose_enrichment_type: "Choose enrichment type",
    classification: "Automatic classification",
    classification_categories: "Classification categories",
    clearfilters: "Clear filters",
    click_search_step: "Click the search button or press Ctrl+Enter",
    close: "close",
    comments: "Comments",
    company: "Company",
    compare_period: "Comparison period",
    condition_met: "Condition met",
    condition_not_met: "Condition not met",
    configuration: "Configuration",
    confirm: "Confirm",
    confirmpassword: "Confirm password",
    connect: "Sign In",
    contact_admin:
      "Contact your administrator to be assigned to an organization",
    cooldown: "Cooldown period",
    cooldown_12h: "12 hours",
    cooldown_1h: "1 hour",
    cooldown_24h: "24 hours",
    cooldown_3d: "3 days",
    cooldown_6h: "6 hours",
    cooldown_7d: "7 days",
    cooldown_desc: "Minimum time between two triggers.",
    cooldown_none: "None",
    copied_to_clipboard: "Copied to clipboard",
    count: "Count",
    create: "Create",
    create_enrichment_modal: "Create enrichment",
    create_first_category: "Create the first category",
    create_first_entity_type: "Create the first entity type",
    create_first_token: "Create Your First Token",
    create_first_workspace: "Create Your First Workspace",
    create_new_token: "Create New Token",
    create_token: "Create Token",
    create_token_description:
      "Create an API token to authenticate your requests",
    create_widget: "Create Widget",
    create_workspace: "Create Workspace",
    create_workspace_description: "Create your first workspace to get started",
    createalert: "Create Alert",
    created_at: "Created At",
    createnewdashboard: "Create a new dashboard",
    current_period: "Current period",
    custom_desc: "Define a custom Elasticsearch query.",
    custom_entity_types: "Custom entity types",
    customize_language: "Customize your interface language",
    dashboardCreated: "Dashboard created successfully",
    dashboardName: "Dashboard name",
    dashboardNameRequired: "Dashboard name is required",
    dashboardNameTooLong: "Dashboard name is too long (max 100 characters)",
    dashboardNotCreated: "Error creating dashboard",
    dashboards: "Dashboards",
    dashboards_desc: "Alert will be evaluated on data from these dashboards.",
    date_range: "Date range",
    days: "days",
    days_ago: "d ago",
    days_short: "d",
    define_categories_description: "Create your own classification categories",
    delete: "Delete",
    delete_token: "Delete Token",
    delete_token_confirmation:
      "Are you sure you want to delete this token? This action cannot be undone and any applications using this token will lose access.",
    delete_workspace: "Delete Workspace",
    delete_workspace_confirmation:
      "Are you sure you want to delete this workspace? All associated data will be lost.",
    deletealertquestion: "Delete Alert?",
    deletechannelquestion: "Delete channel?",
    description: "Description",
    details: "Details",
    disabled: "Disabled",
    doccount: "Document count",
    document_count: "Document count",
    duplicate: "Duplicate",
    duplicatename: "This name is already taken",
    edit: "Edit",
    edit_token: "Edit Token",
    edit_workspace: "Edit Workspace",
    editalert: "Edit alert",
    editor: "Editor",
    editor_description: "Can create, read, and update content",
    email: "Email",
    emailaddress: "Email address",
    emailexists: "An account with this email already exists",
    emailrequired: "Email is required",
    embed_view: "Embed view",
    embed_view_description: "Native social media embeds",
    enabled: "Enabled",
    enrichment_description: "Description (optional)",
    enrichment_name: "Enrichment name",
    enterDashboardDescription: "Enter a description for this dashboard",
    enterDashboardName: "Enter dashboard name",
    enter_query_step: "Enter your search query",
    entercredentials: "Enter your credentials to continue",
    enternewpassword: "Enter new password",
    error: "Error",
    error404: "404 - Page not found",
    error500: "An error occured",
    es_query: "Elasticsearch query (JSON)",
    example: "Example",
    expires_at: "Expires At",
    export_current_data: "Export current data",
    export_processing: "Export processing",
    external_link: "External link",
    field: "Field",
    field_placeholder: "e.g. sentiment_score",
    filters: "Filters",
    filtersappliedfailed: "Filters failed to apply",
    filtersappliedsuccess: "Filters applied successfully",
    filtre: "Filter",
    followers: "followers",
    forgotpasswordquestion: "Forgot password?",
    format: "Format",
    getback: "Reset",
    grid_view: "Grid view",
    grid_view_description: "Cards in a grid layout",
    hours_ago: "h ago",
    hours_short: "h",
    how_to_search: "How to search",
    inactive: "Inactive",
    inactive_alerts: "Inactive",
    interval_12h: "12 hours",
    interval_15min: "15 min",
    interval_1h: "1 hour",
    interval_24h: "24 hours",
    interval_30min: "30 min",
    interval_5min: "5 min",
    interval_6h: "6 hours",
    invalid_json: "Invalid JSON",
    just_now: "Just now",
    keyboard_shortcuts: "Keyboard Shortcuts",
    lang: "Language",
    language: "Language",
    language_description: "Select your preferred language for the interface",
    language_preferences: "Language preferences",
    last_check: "Last check",
    last_trigger: "Last",
    less_alerts: "Fewer alerts",
    likes: "Likes",
    limits_usage: "Limits & Usage",
    list_view: "List view",
    list_view_description: "Compact list format",
    loading: "Loading",
    loadingDashboard: "Loading dashboard...",
    logout: "Logout",
    logout_description:
      "Sign out of your account. You will need to log in again to access your account",
    manage_api_access: "Create and manage API tokens for authentication",
    manage_notification_channels: "Manage your notification and alert channels",
    manage_team_access: "Manage access and roles for your team members",
    manage_workspaces_description:
      "Organize your work into separate workspaces",
    mark_all_read: "Mark all as read",
    masonry_view: "Masonry view",
    masonry_view_description: "Pinterest-style layout",
    maximum: "Maximum",
    member_added: "Member added successfully",
    member_removed: "Member removed successfully",
    member_updated: "Member role updated successfully",
    members: "Members",
    mentions: "Mentions",
    metric: "Metric",
    metric_to_monitor: "Metric to monitor",
    min_documents: "Minimum number of documents",
    minimum: "Minimum",
    minutes_ago: "min ago",
    minutes_short: "min",
    more_alerts: "More alerts",
    morefilters: "More filters",
    mustvalidmail: "Must be a valid email",
    mychannels: "My channels",
    name: "Name",
    named_entity_recognition: "Named Entity Recognition",
    never_triggered: "Never triggered",
    new: "new",
    new_documents_desc:
      "Alert will trigger when document count exceeds the threshold.",
    newpassword: "New password",
    next: "Next",
    no_categories: "No categories defined",
    no_channels_warning:
      "No channels configured. Create a channel first in settings.",
    no_entity_types: "No entity types defined",
    no_expiration: "No expiration",
    no_matching_alerts: "No matching alerts",
    no_members: "No members yet",
    no_notifications: "No notifications",
    no_notifications_desc: "You will be notified when an alert triggers",
    no_organization: "No organization assigned",
    no_parameters_available: "No parameters available for this tracker",
    no_results_found: "No results found",
    no_tokens: "No API tokens yet",
    no_tracker_found: "No tracker found",
    no_workspaces: "No workspaces yet",
    noalert: "No Alert",
    noalertdescription:
      "Create your first alert to be notified automatically when conditions are met",
    nochannel: "No channel for your account. Add one to receive notifications",
    nodashboard: "No dashboard available",
    nofilter: "No filter",
    nofilters: "No filters found",
    nohistory: "No history",
    nohistorydescription:
      "This alert has not been evaluated yet. History will appear here after the first check.",
    notifications: "Notifications",
    notified: "Notified",
    notrackers: "No trackers",
    operator: "Operator",
    optional: "optional",
    optional_parameters: "Optional parameters",
    gateway_parameters: "Gateway parameters",
    or: "Or",
    organization: "Organization",
    organization_info: "View your organization details and configuration",
    organization_members: "Organization Members",
    organization_name: "Organization name",
    password: "Password",
    password_too_weak:
      "Password is too weak. Use at least 8 characters, with uppercase, lowercase, numbers, and special characters.",
    password_strength_weak: "Weak",
    password_strength_fair: "Fair",
    password_strength_good: "Good",
    password_strength_strong: "Strong",
    password_strength_very_strong: "Very strong",
    passwordmustmatch: "Passwords must match",
    passwordrequired: "Password is required",
    passwordupdated: "Password updated",
    pdfquality: "PDF quality",
    period: "Period",
    personal: "Personal",
    phone: "Phone",
    post_details: "Post details",
    postedon: "Published date",
    posts: "Posts",
    prev: "previous",
    previous: "Previous",
    publication_info: "Publication information",
    published_on: "Published on",
    reader: "Reader",
    reader_description: "Read-only access",
    rememberme: "Remember me",
    remove: "Remove",
    remove_member: "Remove Member",
    remove_member_confirmation:
      "Are you sure you want to remove this member from the organization? They will lose access to organization resources.",
    requests: "Requests",
    restricted_access: "Restricted Access",
    results: "Results",
    role: "Role",
    role_permissions: "Role Permissions",
    run: "Run",
    run_now: "Run now",
    save: "Save",
    saveChanges: "Save changes",
    saving: "Saving...",
    schedule_settings: "Schedule settings",
    search: "Search",
    search_alerts: "Search alerts...",
    search_description: "Select a source and tracker to search for content",
    search_for: "Search for",
    search_help: "Search Help",
    search_shortcuts: "Search shortcuts",
    search_tips: "Search Tips",
    search_title: "Search",
    select_alert_type: "Choose the alert type",
    select_channels: "Notification channels",
    select_channels_placeholder: "Choose channels...",
    select_dashboards: "Select dashboards to monitor",
    select_dashboards_placeholder: "Choose dashboards...",
    select_role: "Select Role",
    select_source: "Select source",
    select_source_step: "Select a source (Twitter, Facebook, etc.)",
    select_tracker: "Select tracker",
    select_tracker_step: "Choose a tracker type (keywords, hashtags, etc.)",
    select_user: "Select User",
    sensitivity: "Sensitivity",
    shares: "Shares",
    shortcut_search: "Launch search",
    signin: "Sign in",
    signup: "Sign up",
    source: "Source",
    statistics: "Statistics",
    status: "Status",
    step_config: "Configuration",
    step_notifications: "Notifications",
    step_schedule: "Schedule",
    step_targets: "Targets",
    step_type: "Type",
    submit: "Submit",
    sum: "Sum",
    summary: "Summary",
    team: "Team",
    technical_details: "Technical details",
    test: "Test",
    threshold_desc: "Alert will trigger when the metric reaches the threshold.",
    threshold_value: "Threshold value",
    timeline_view: "Timeline view",
    timeline_view_description: "Chronological timeline",
    tip_1: "Use specific keywords for better results",
    tip_2: "Try different tracker types for the same source",
    tip_3: "Use suggestions to find popular terms",
    tip_4: "Check the statistics for result insights",
    token: "Token",
    token_created: "Token created successfully",
    token_created_message:
      "Your token has been created. Make sure to copy it now. You won't be able to see it again!",
    token_deleted: "Token deleted successfully",
    token_name: "Token Name",
    token_name_required: "Token name is required",
    token_updated: "Token updated successfully",
    total: "Total",
    total_alerts: "Total",
    tracker: "Tracker",
    trackercreated: "Tracker saved",
    trackerdeleted: "Tracker deleted",
    trackers: "Trackers",
    triggered: "Triggered",
    triggered_today: "Triggered",
    triggers: "triggers",
    try_different_filters: "Try modifying your search filters",
    try_different_keywords: "Try different keywords or search terms",
    type: "Type",
    unique_sources: "Unique sources",
    unsupported_media: "Unsupported media type",
    update: "Update",
    update_password_description:
      "Update your password to keep your account secure",
    usage_limits_description: "Current usage and plan limits",
    usage_over_time: "Usage over time",
    used: "used",
    user: "User",
    user_required: "Please select a user",
    value: "Value",
    verified: "Verified",
    view_all_alerts: "View all alerts",
    view_details: "View details",
    view_original: "View original",
    what_are_workspaces: "What are workspaces?",
    workspace_created: "Workspace created successfully",
    workspace_deleted: "Workspace deleted successfully",
    workspace_name: "Workspace Name",
    workspace_name_required: "Workspace name is required",
    workspace_updated: "Workspace updated successfully",
    workspaces: "Workspaces",
    workspaces_description:
      "Workspaces allow you to organize your projects, trackers, and dashboards. Each workspace is isolated and can have its own settings and members.",
    deletetopicquestion: "Delete topic?",
    forgotpassword: "Forgot password",
    unlimitedtopics: "Unlimited topics",
    location: "Location",
    // Plural: bulk operation messages
    n_dashboards_deleted_one: "{{count}} dashboard deleted",
    n_dashboards_deleted_other: "{{count}} dashboards deleted",
    n_dashboards_duplicated_one: "{{count}} dashboard duplicated",
    n_dashboards_duplicated_other: "{{count}} dashboards duplicated",
    n_dashboards_pinned_one: "{{count}} dashboard pinned",
    n_dashboards_pinned_other: "{{count}} dashboards pinned",
    n_dashboards_unpinned_one: "{{count}} dashboard unpinned",
    n_dashboards_unpinned_other: "{{count}} dashboards unpinned",
    n_dashboards_color_changed_one: "Color changed for {{count}} dashboard",
    n_dashboards_color_changed_other: "Color changed for {{count}} dashboards",
    n_trackers_deleted_one: "{{count}} tracker deleted",
    n_trackers_deleted_other: "{{count}} trackers deleted",
    n_trackers_activated_one: "{{count}} tracker activated",
    n_trackers_activated_other: "{{count}} trackers activated",
    n_trackers_deactivated_one: "{{count}} tracker deactivated",
    n_trackers_deactivated_other: "{{count}} trackers deactivated",
    n_trackers_executed_one: "{{count}} tracker executed",
    n_trackers_executed_other: "{{count}} trackers executed",
    n_trackers_tags_added_one: "Tags added to {{count}} tracker",
    n_trackers_tags_added_other: "Tags added to {{count}} trackers",
    n_enrichments_deleted_one: "{{count}} enrichment deleted",
    n_enrichments_deleted_other: "{{count}} enrichments deleted",
    n_enrichments_activated_one: "{{count}} enrichment activated",
    n_enrichments_activated_other: "{{count}} enrichments activated",
    n_enrichments_deactivated_one: "{{count}} enrichment deactivated",
    n_enrichments_deactivated_other: "{{count}} enrichments deactivated",
    n_enrichments_executed_one: "{{count}} enrichment executed",
    n_enrichments_executed_other: "{{count}} enrichments executed",
    n_enrichments_applied_one:
      "{{count}} enrichment applied to selected trackers",
    n_enrichments_applied_other:
      "{{count}} enrichments applied to selected trackers",
    n_alerts_deleted_one: "{{count}} alert deleted",
    n_alerts_deleted_other: "{{count}} alerts deleted",
    n_alerts_activated_one: "{{count}} alert activated",
    n_alerts_activated_other: "{{count}} alerts activated",
    n_alerts_deactivated_one: "{{count}} alert deactivated",
    n_alerts_deactivated_other: "{{count}} alerts deactivated",
    n_alerts_executed_one: "{{count}} alert executed",
    n_alerts_executed_other: "{{count}} alerts executed",
    n_widgets_deleted_one: "{{count}} widget deleted",
    n_widgets_deleted_other: "{{count}} widgets deleted",
    n_investigations_deleted_one: "{{count}} investigation deleted",
    n_investigations_deleted_other: "{{count}} investigations deleted",
    // Plural: error messages
    n_dashboards_delete_failed_one: "Failed to delete {{count}} dashboard",
    n_dashboards_delete_failed_other: "Failed to delete {{count}} dashboards",
    n_dashboards_duplicate_failed_one:
      "Failed to duplicate {{count}} dashboard",
    n_dashboards_duplicate_failed_other:
      "Failed to duplicate {{count}} dashboards",
    n_dashboards_color_change_failed_one:
      "Failed to change color for {{count}} dashboard",
    n_dashboards_color_change_failed_other:
      "Failed to change color for {{count}} dashboards",
    n_trackers_delete_failed_one: "Failed to delete {{count}} tracker",
    n_trackers_delete_failed_other: "Failed to delete {{count}} trackers",
    n_trackers_execute_failed_one: "Failed to execute {{count}} tracker",
    n_trackers_execute_failed_other: "Failed to execute {{count}} trackers",
    n_trackers_activate_failed_one: "Failed to activate {{count}} tracker",
    n_trackers_activate_failed_other: "Failed to activate {{count}} trackers",
    n_trackers_deactivate_failed_one: "Failed to deactivate {{count}} tracker",
    n_trackers_deactivate_failed_other:
      "Failed to deactivate {{count}} trackers",
    n_trackers_tags_failed_one: "Failed to update tags for {{count}} tracker",
    n_trackers_tags_failed_other:
      "Failed to update tags for {{count}} trackers",
    n_enrichments_delete_failed_one: "Failed to delete {{count}} enrichment",
    n_enrichments_delete_failed_other: "Failed to delete {{count}} enrichments",
    n_enrichments_execute_failed_one: "Failed to execute {{count}} enrichment",
    n_enrichments_execute_failed_other:
      "Failed to execute {{count}} enrichments",
    n_enrichments_activate_failed_one:
      "Failed to activate {{count}} enrichment",
    n_enrichments_activate_failed_other:
      "Failed to activate {{count}} enrichments",
    n_enrichments_deactivate_failed_one:
      "Failed to deactivate {{count}} enrichment",
    n_enrichments_deactivate_failed_other:
      "Failed to deactivate {{count}} enrichments",
    n_alerts_delete_failed_one: "Failed to delete {{count}} alert",
    n_alerts_delete_failed_other: "Failed to delete {{count}} alerts",
    n_alerts_activate_failed_one: "Failed to activate {{count}} alert",
    n_alerts_activate_failed_other: "Failed to activate {{count}} alerts",
    n_alerts_deactivate_failed_one: "Failed to deactivate {{count}} alert",
    n_alerts_deactivate_failed_other: "Failed to deactivate {{count}} alerts",
    n_alerts_execute_failed_one: "Failed to execute {{count}} alert",
    n_alerts_execute_failed_other: "Failed to execute {{count}} alerts",
    n_widgets_delete_failed_one: "Failed to delete {{count}} widget",
    n_widgets_delete_failed_other: "Failed to delete {{count}} widgets",
    n_investigations_delete_failed_one:
      "Failed to delete {{count}} investigation",
    n_investigations_delete_failed_other:
      "Failed to delete {{count}} investigations",
    // Plural: progress messages
    deleting_n_trackers_one: "Deleting {{count}} tracker…",
    deleting_n_trackers_other: "Deleting {{count}} trackers…",
    executing_n_trackers_one: "Executing {{count}} tracker…",
    executing_n_trackers_other: "Executing {{count}} trackers…",
    activating_n_trackers_one: "Activating {{count}} tracker…",
    activating_n_trackers_other: "Activating {{count}} trackers…",
    deactivating_n_trackers_one: "Deactivating {{count}} tracker…",
    deactivating_n_trackers_other: "Deactivating {{count}} trackers…",
    adding_tags_n_trackers_one: "Adding tags to {{count}} tracker…",
    adding_tags_n_trackers_other: "Adding tags to {{count}} trackers…",
    executing_n_enrichments_one: "Executing {{count}} enrichment…",
    executing_n_enrichments_other: "Executing {{count}} enrichments…",
    activating_n_enrichments_one: "Activating {{count}} enrichment…",
    activating_n_enrichments_other: "Activating {{count}} enrichments…",
    deactivating_n_enrichments_one: "Deactivating {{count}} enrichment…",
    deactivating_n_enrichments_other: "Deactivating {{count}} enrichments…",
    // Plural: UI display messages
    n_sources_one: "{{count}} source",
    n_sources_other: "{{count}} sources",
    n_trackers_count_one: "{{count}} tracker",
    n_trackers_count_other: "{{count}} trackers",
    n_documents_one: "{{count}} document",
    n_documents_other: "{{count}} documents",
    n_documents_found_one: "{{count}} document found",
    n_documents_found_other: "{{count}} documents found",
    n_documents_loaded_one: "{{count}} document loaded",
    n_documents_loaded_other: "{{count}} documents loaded",
    n_documents_imported_one: "{{count}} document imported successfully",
    n_documents_imported_other: "{{count}} documents imported successfully",
    n_documents_ready_one: "{{count}} document ready to import",
    n_documents_ready_other: "{{count}} documents ready to import",
    n_selected_one: "{{count}} selected",
    n_selected_other: "{{count}} selected",
    n_trackers_selected_one: "{{count}} tracker selected",
    n_trackers_selected_other: "{{count}} trackers selected",
    n_rows_one: "{{count}} row",
    n_rows_other: "{{count}} rows",
    n_elements_one: "{{count}} element",
    n_elements_other: "{{count}} elements",
    n_properties_one: "Object with {{count}} property",
    n_properties_other: "Object with {{count}} properties",
    n_branches_one: "{{count}} branch",
    n_branches_other: "{{count}} branches",
    n_commits_one: "{{count}} commit",
    n_commits_other: "{{count}} commits",
    n_executions_found_one: "{{count}} execution found",
    n_executions_found_other: "{{count}} executions found",
    n_queries_configured_one: "{{count}} query configured",
    n_queries_configured_other: "{{count}} queries configured",
    n_values_one: "{{count}} value",
    n_values_other: "{{count}} values",
    n_operations_applied_one: "Merge successful: {{count}} operation applied",
    n_operations_applied_other:
      "Merge successful: {{count}} operations applied",
    n_operations_skipped_one: "{{count}} operation skipped (conflicts)",
    n_operations_skipped_other: "{{count}} operations skipped (conflicts)",
    n_investigations_will_be_deleted_one:
      "{{count}} investigation will be deleted.",
    n_investigations_will_be_deleted_other:
      "{{count}} investigations will be deleted.",
    n_dashboards_will_be_deleted_one: "{{count}} dashboard will be deleted.",
    n_dashboards_will_be_deleted_other: "{{count}} dashboards will be deleted.",
    import_n_documents_one: "Import {{count}} document",
    import_n_documents_other: "Import {{count}} documents",
    tab_created_with_n_widgets_one:
      'Tab "{{name}}" created with {{count}} widget.',
    tab_created_with_n_widgets_other:
      'Tab "{{name}}" created with {{count}} widgets.',
    n_widgets_one: "{{count}} widget",
    n_widgets_other: "{{count}} widgets",
    execution_completed_n_new_documents_one:
      "Execution completed — {{count}} new document",
    execution_completed_n_new_documents_other:
      "Execution completed — {{count}} new documents",
    enrichment_completed_n_documents_one:
      "Enrichment completed — {{count}} document enriched",
    enrichment_completed_n_documents_other:
      "Enrichment completed — {{count}} documents enriched",
    n_documents_deleted_one: "{{count}} document deleted",
    n_documents_deleted_other: "{{count}} documents deleted",
    see_n_more_documents_one: "See {{count}} more document",
    see_n_more_documents_other: "See {{count}} more documents",
    n_active_filters_one: "{{count}} active filter",
    n_active_filters_other: "{{count}} active filters",
    validate_n_selected_one: "Validate ({{count}} selected)",
    validate_n_selected_other: "Validate ({{count}} selected)",
    n_enrichments_to_apply_one: "{{count}} enrichment to apply",
    n_enrichments_to_apply_other: "{{count}} enrichments to apply",
    n_of_total_selected_one: "{{count}} / {{total}} selected",
    n_of_total_selected_other: "{{count}} / {{total}} selected",
    n_of_total_trackers_selected_one: "{{count}} / {{total}} tracker selected",
    n_of_total_trackers_selected_other:
      "{{count}} / {{total}} trackers selected",
    n_sources_available_one: "{{count}}/{{total}} source",
    n_sources_available_other: "{{count}}/{{total}} sources",
    n_tags_selected_one: "{{count}} tag selected",
    n_tags_selected_other: "{{count}} tags selected",
    n_custom_params_one: "{{count}} custom parameter",
    n_custom_params_other: "{{count}} custom parameters",
    // Plural: execution status labels
    n_success_one: "{{count}} success",
    n_success_other: "{{count}} successes",
    n_errors_one: "{{count}} error",
    n_errors_other: "{{count}} errors",
    n_running_one: "{{count}} running",
    n_running_other: "{{count}} running",
    success_rate: "{{rate}}% success",
    error_rate: "{{rate}}% errors",
    // Plural: noun-only labels (for stat cards / tabs where the count is displayed separately)
    execution_label_one: "Execution",
    execution_label_other: "Executions",
    document_label_one: "Document",
    document_label_other: "Documents",
  },
  fr: {
    "1day": "1 jour",
    "1month": "1 mois",
    "1week": "1 semaine",
    "1year": "1 an",
    English: "Anglais",
    French: "Français",
    Good: "Bon",
    Normal: "Normal",
    OR: "OU",
    Poor: "Pauvre",
    Strong: "Fort",
    Weak: "Faible",
    accountactivated: "Utilisateur validé avec succès",
    actions: "Actions",
    activate: "Activer",
    active: "Actif",
    active_alerts: "Actives",
    add: "Ajouter",
    add_category: "Ajouter une catégorie",
    add_channel_description:
      "Ajoutez un canal pour recevoir des notifications et des alertes",
    add_entity_type: "Ajouter un type",
    add_first_member: "Ajouter votre premier membre",
    add_member: "Ajouter un membre",
    add_member_description:
      "Ajoutez des membres pour collaborer dans votre organisation",
    add_new_member: "Ajouter un nouveau membre",
    addchannel: "Ajouter un canal",
    addtrackerstosearchbar: "Ajouter les trackers à la barre de recherche",
    admin: "Administrateur",
    admin_description:
      "Accès complet - peut créer, lire, modifier et supprimer",
    advanced_parameters: "Paramètres avancés",
    advanced_search: "Recherche avancée",
    aggregation: "Agrégation",
    ago: "il y a",
    alert_condition: "Condition de déclenchement",
    alert_description_placeholder: "Décrivez le but de cette alerte...",
    alert_name: "Nom de l'alerte",
    alert_name_placeholder: "Ex: Pic de mentions",
    alert_not_triggered: "Condition non remplie",
    alert_triggered: "Alerte déclenchée",
    alert_type_anomaly: "Anomalie",
    alert_type_anomaly_desc: "Détection automatique d'anomalies",
    alert_type_change: "Changement",
    alert_type_change_desc: "Déclenchement sur variation significative",
    alert_type_custom: "Personnalisé",
    alert_type_custom_desc: "Requête Elasticsearch personnalisée",
    alert_type_new_documents: "Nouveaux documents",
    alert_type_new_documents_desc: "Déclenchement lors de nouveaux documents",
    alert_type_threshold: "Seuil",
    alert_type_threshold_desc:
      "Déclenchement quand une métrique dépasse un seuil",
    alertcreated: "Alerte créée!",
    alertdeleted: "Alerte supprimée",
    alerthistory: "Historique de l'alerte",
    alerts: "Alertes",
    alerts_description:
      "Configurez des alertes pour être notifié automatiquement",
    alertupdated: "Alerte mise à jour",
    all_status: "Tous les statuts",
    all_types: "Tous les types",
    anomaly_desc:
      "L'alerte détectera automatiquement les comportements anormaux.",
    api_tokens: "Jetons API",
    applyfilters: "Appliquer les filtres",
    available_sources: "Sources disponibles",
    avatars: "Avatars",
    average: "Moyenne",
    back: "Retour",
    back_to_search: "Retour à la recherche",
    back_to_selection: "Retour à la sélection",
    billing_period: "Période de facturation",
    browsers: "Navigateurs",
    cancel: "Annuler",
    card_view: "Vue carte",
    card_view_description: "Cartes détaillées avec médias",
    change: "Modifier",
    change_desc: "L'alerte se déclenchera lors d'un changement significatif.",
    change_member_role: "Changer le rôle du membre",
    change_percentage: "Pourcentage de changement (%)",
    change_role: "Changer le rôle",
    change_view: "Changer la vue",
    changepassword: "Modifier le mot de passe",
    changepasswordsuccess: "Votre mot de passe a été modifié avec succès !",
    channel: "Canal",
    channelcreated: "Canal créé",
    channeldeleted: "Canal supprimé",
    channels: "Canaux",
    channels_desc: "Choisissez comment vous souhaitez être notifié.",
    check_interval: "Intervalle de vérification",
    check_interval_desc: "À quelle fréquence l'alerte doit-elle être évaluée ?",
    checked: "Vérifiée",
    choose_enrichment_type: "Choisir le type d'enrichissement",
    classification: "Classification automatique",
    classification_categories: "Catégories de classification",
    clearfilters: "Effacer les filtres",
    close: "fermer",
    comments: "Commentaires",
    company: "Entreprise",
    compare_period: "Période de comparaison",
    condition_met: "Condition remplie",
    condition_not_met: "Condition non remplie",
    configuration: "Configuration",
    confirm: "Confirmer",
    confirmpassword: "Mot de passe de confirmation",
    connect: "Connexion",
    contact_admin:
      "Contactez votre administrateur pour être assigné à une organisation",
    cooldown: "Période de silence",
    cooldown_12h: "12 heures",
    cooldown_1h: "1 heure",
    cooldown_24h: "24 heures",
    cooldown_3d: "3 jours",
    cooldown_6h: "6 heures",
    cooldown_7d: "7 jours",
    cooldown_desc: "Temps minimum entre deux déclenchements.",
    cooldown_none: "Aucun",
    copied_to_clipboard: "Copié dans le presse-papiers",
    count: "Nombre",
    create: "Créer",
    create_enrichment_modal: "Créer un enrichissement",
    create_first_category: "Créer la première catégorie",
    create_first_entity_type: "Créer le premier type",
    create_first_token: "Créer votre premier jeton",
    create_first_workspace: "Créer votre premier espace de travail",
    create_new_token: "Créer un nouveau jeton",
    create_token: "Créer un jeton",
    create_token_description:
      "Créez un jeton API pour authentifier vos requêtes",
    create_widget: "Creer un widget",
    create_workspace: "Créer un espace de travail",
    create_workspace_description:
      "Créez votre premier espace de travail pour commencer",
    createalert: "Créer une alerte",
    created_at: "Créé le",
    createnewdashboard: "Créer un nouveau tableau de bord",
    current_period: "Période en cours",
    custom_desc: "Définissez une requête Elasticsearch personnalisée.",
    custom_entity_types: "Types d'entités personnalisés",
    customize_language: "Personnalisez la langue de l'interface",
    dashboardCreated: "Dashboard créé avec succès",
    dashboardName: "Nom du dashboard",
    dashboardNameRequired: "Le nom du dashboard est requis",
    dashboardNameTooLong:
      "Le nom du dashboard est trop long (max 100 caractères)",
    dashboardNotCreated: "Erreur lors de la création du dashboard",
    dashboards: "Tableaux de bord",
    dashboards_desc: "L'alerte sera évaluée sur les données de ces dashboards.",
    date_range: "Plage de dates",
    days: "jours",
    days_ago: "j",
    days_short: "j",
    delete: "Supprimer",
    delete_token: "Supprimer le jeton",
    delete_token_confirmation:
      "Êtes-vous sûr de vouloir supprimer ce jeton ? Cette action est irréversible et toutes les applications utilisant ce jeton perdront l'accès.",
    delete_workspace: "Supprimer l'espace de travail",
    delete_workspace_confirmation:
      "Êtes-vous sûr de vouloir supprimer cet espace de travail ? Toutes les données associées seront perdues.",
    deletealertquestion: "Supprimer l'alerte ?",
    deletechannelquestion: "Supprimer le canal?",
    deletetopicquestion: "Supprimer le sujet ?",
    description: "Description",
    details: "Détails",
    disabled: "Désactivées",
    document_count: "Nombre de documents",
    duplicate: "Dupliquer",
    duplicatename: "Ce nom existe déjà",
    edit: "Modifier",
    edit_token: "Modifier le jeton",
    edit_workspace: "Modifier l'espace de travail",
    editalert: "Modifier l'alerte",
    editor: "Éditeur",
    editor_description: "Peut créer, lire et modifier le contenu",
    email: "Email",
    emailaddress: "Adresse mail",
    emailexists: "Un compte avec cet email existe déjà",
    emailrequired: "Adresse mail requise",
    embed_view: "Vue embed",
    embed_view_description: "Embeds natifs des réseaux sociaux",
    enabled: "Activées",
    enrichment_description: "Description (optionnel)",
    enrichment_name: "Nom de l'enrichissement",
    enterDashboardDescription: "Entrez une description pour ce dashboard",
    enterDashboardName: "Entrez le nom du dashboard",
    enter_query_step: "Entrez votre requête de recherche",
    entercredentials: "Entrez vos informations pour continuer",
    enternewpassword: "Entrer le nouveau mot de passe",
    error: "Erreur",
    error404: "404 - Page introuvable",
    error500: "Une erreur est survenue",
    es_query: "Requête Elasticsearch (JSON)",
    example: "Exemple",
    expires_at: "Expire le",
    export_current_data: "Exporter les données actuelles",
    export_processing: "Export en cours de création",
    external_link: "Lien externe",
    field: "Champ",
    field_placeholder: "ex: sentiment_score",
    filters: "Filtres",
    filtre: "Filtre",
    followers: "followers",
    forgotpassword: "Mot de passe oublié",
    forgotpasswordquestion: "Mot de passe oublié ?",
    format: "Format",
    getback: "Récupérer",
    grid_view: "Vue grille",
    grid_view_description: "Cartes en disposition grille",
    hours_ago: "h",
    hours_short: "h",
    how_to_search: "Comment rechercher",
    inactive: "Inactif",
    inactive_alerts: "Inactives",
    interval_12h: "12 heures",
    interval_15min: "15 min",
    interval_1h: "1 heure",
    interval_24h: "24 heures",
    interval_30min: "30 min",
    interval_5min: "5 min",
    interval_6h: "6 heures",
    invalid_json: "JSON invalide",
    just_now: "À l'instant",
    keyboard_shortcuts: "Raccourcis clavier",
    lang: "Langue",
    language: "Langue",
    language_description: "Sélectionnez votre langue préférée pour l'interface",
    language_preferences: "Préférences de langue",
    last_check: "Dernière vérif.",
    last_trigger: "Dernière",
    less_alerts: "Moins d'alertes",
    likes: "Likes",
    limits_usage: "Limites et utilisation",
    list_view: "Vue liste",
    list_view_description: "Format liste compact",
    loading: "Chargement",
    loadingDashboard: "Chargement du dashboard...",
    location: "Lieu",
    logout: "Déconnexion",
    logout_description:
      "Déconnectez-vous de votre compte. Vous devrez vous reconnecter pour y accéder",
    manage_api_access: "Créez et gérez des jetons API pour l'authentification",
    manage_notification_channels:
      "Gérez vos canaux de notification et d'alerte",
    manage_team_access: "Gérez les accès et les rôles de votre équipe",
    manage_workspaces_description:
      "Organisez votre travail dans des espaces de travail séparés",
    mark_all_read: "Tout marquer comme lu",
    masonry_view: "Vue masonry",
    masonry_view_description: "Disposition style Pinterest",
    maximum: "Maximum",
    member_added: "Membre ajouté avec succès",
    member_removed: "Membre retiré avec succès",
    member_updated: "Rôle du membre mis à jour avec succès",
    members: "Membres",
    mentions: "mentions",
    metric: "Valeur",
    metric_to_monitor: "Métrique à surveiller",
    min_documents: "Nombre minimum de documents",
    minimum: "Minimum",
    minutes_ago: "min",
    minutes_short: "min",
    more_alerts: "Plus d'alertes",
    morefilters: "Plus de filtres",
    mustvalidmail: "Doit être un mail valide",
    mychannels: "Mes canaux",
    name: "Nom",
    named_entity_recognition: "Extraction d'entités nommées",
    never_triggered: "Jamais déclenchée",
    new: "nouvelles",
    new_documents_desc:
      "L'alerte se déclenchera lorsque le nombre de documents dépasse le seuil.",
    newpassword: "Nouveau mot de passe",
    next: "Suivant",
    no_categories: "Aucune catégorie définie",
    no_channels_warning:
      "Aucun canal configuré. Créez d'abord un canal dans les paramètres.",
    no_entity_types: "Aucun type d'entité défini",
    no_expiration: "Pas d'expiration",
    no_matching_alerts: "Aucune alerte correspondante",
    no_members: "Aucun membre pour le moment",
    no_notifications: "Aucune notification",
    no_notifications_desc:
      "Vous serez notifié lorsqu'une alerte se déclenchera",
    no_organization: "Aucune organisation assignée",
    no_parameters_available: "Aucun paramètre disponible pour ce tracker",
    no_results_found: "Aucun résultat trouvé",
    no_tokens: "Aucun jeton API pour le moment",
    no_tracker_found: "Aucun tracker trouvé",
    no_workspaces: "Aucun espace de travail pour le moment",
    noalert: "Aucune alerte",
    noalertdescription:
      "Créez votre première alerte pour être notifié automatiquement lorsque des conditions sont remplies",
    nodashboard: "Pas de tableau de bord disponible",
    nofilters: "Aucun filtre trouvés",
    nohistory: "Aucun historique",
    nohistorydescription:
      "Cette alerte n'a pas encore été évaluée. L'historique apparaîtra ici après la première vérification.",
    notifications: "Notifications",
    notified: "Notifié",
    notrackers: "Aucun tracker",
    operator: "Opérateur",
    optional: "optionnel",
    optional_parameters: "Paramètres optionnels",
    gateway_parameters: "Paramètres gateway",
    or: "Ou",
    organization: "Entreprises",
    organization_info:
      "Consultez les détails et la configuration de votre organisation",
    organization_members: "Membres de l'organisation",
    organization_name: "Nom de l'organisation",
    password: "Mot de passe",
    password_too_weak:
      "Le mot de passe est trop faible. Utilisez au moins 8 caractères, avec des majuscules, minuscules, chiffres et caractères spéciaux.",
    password_strength_weak: "Faible",
    password_strength_fair: "Moyen",
    password_strength_good: "Bon",
    password_strength_strong: "Fort",
    password_strength_very_strong: "Très fort",
    passwordmustmatch: "Le mot de passe doit être identique",
    passwordrequired: "Mot de passe requis",
    passwordupdated: "Identifiants mis à jour",
    period: "Période",
    personal: "Personnel",
    phone: "Téléphone",
    post_details: "Détails du poste",
    postedon: "Date de publication",
    posts: "Posts",
    previous: "Précédent",
    publication_info: "Informations de publication",
    published_on: "Publié le",
    reader: "Lecteur",
    reader_description: "Accès en lecture seule",
    rememberme: "Se souvenir de moi",
    remove: "Supprimer",
    remove_member: "Retirer le membre",
    remove_member_confirmation:
      "Êtes-vous sûr de vouloir retirer ce membre de l'organisation ? Il perdra l'accès aux ressources de l'organisation.",
    requests: "Requêtes",
    restricted_access: "Accès restreint",
    results: "résultats",
    role: "Rôle",
    role_permissions: "Permissions des rôles",
    run: "Exécuter",
    run_now: "Exécuter maintenant",
    save: "Sauvegarder",
    saveChanges: "Sauvegarder les modifications",
    saving: "Sauvegarde en cours...",
    schedule_settings: "Paramètres de planification",
    search: "Rechercher",
    search_alerts: "Rechercher une alerte...",
    search_for: "Recherche pour",
    search_help: "Aide à la recherche",
    search_shortcuts: "Raccourcis de recherche",
    search_tips: "Conseils de recherche",
    search_title: "Recherche",
    select_alert_type: "Choisissez le type d'alerte",
    select_channels: "Canaux de notification",
    select_channels_placeholder: "Choisir des canaux...",
    select_dashboards: "Sélectionnez les dashboards à surveiller",
    select_dashboards_placeholder: "Choisir des dashboards...",
    select_role: "Sélectionner un rôle",
    select_source: "Sélectionner une source",
    select_source_step: "Sélectionnez une source (Twitter, Facebook, etc.)",
    select_tracker: "Sélectionner un tracker",
    select_user: "Sélectionner un utilisateur",
    sensitivity: "Sensibilité",
    shares: "Partages",
    shortcut_search: "Lancer la recherche",
    signin: "Se connecter",
    signup: "S'inscrire",
    source: "Source",
    statistics: "Statistiques",
    status: "Statut",
    step_config: "Configuration",
    step_notifications: "Notifications",
    step_schedule: "Planification",
    step_targets: "Cibles",
    step_type: "Type",
    submit: "Confirmer",
    sum: "Somme",
    summary: "Résumé",
    team: "Équipe",
    technical_details: "Détails techniques",
    test: "Tester",
    threshold_desc:
      "L'alerte se déclenchera lorsque la métrique atteint le seuil.",
    threshold_value: "Valeur seuil",
    timeline_view: "Vue chronologique",
    timeline_view_description: "Timeline chronologique",
    tip_1: "Utilisez des mots-clés spécifiques pour de meilleurs résultats",
    tip_2: "Essayez différents types de trackers pour la même source",
    tip_3: "Utilisez les suggestions pour trouver des termes populaires",
    tip_4: "Consultez les statistiques pour des insights sur les résultats",
    token: "Token",
    token_created: "Jeton créé avec succès",
    token_created_message:
      "Votre jeton a été créé. Assurez-vous de le copier maintenant. Vous ne pourrez plus le voir par la suite !",
    token_deleted: "Jeton supprimé avec succès",
    token_name: "Nom du jeton",
    token_name_required: "Le nom du jeton est requis",
    token_updated: "Jeton mis à jour avec succès",
    total: "Total",
    total_alerts: "Total",
    tracker: "Tracker",
    trackercreated: "Tracker enregistré",
    trackerdeleted: "Tracker supprimé",
    trackers: "Trackers",
    triggered: "Déclenchée",
    triggered_today: "Déclenchées",
    triggers: "déclenchements",
    try_different_filters: "Essayez de modifier vos filtres de recherche",
    try_different_keywords: "Essayez d'autres mots-clés ou termes de recherche",
    type: "Type",
    unique_sources: "Sources uniques",
    unlimitedtopics: "Sujets illimités",
    unsupported_media: "Type de média non supporté",
    update: "Mettre à jour",
    update_password_description:
      "Mettez à jour votre mot de passe pour sécuriser votre compte",
    usage_limits_description: "Utilisation actuelle et limites du plan",
    usage_over_time: "Utilisation au fil du temps",
    used: "utilisé",
    user: "Utilisateur",
    user_required: "Veuillez sélectionner un utilisateur",
    value: "Valeur",
    verified: "Vérifiés",
    view_all_alerts: "Voir toutes les alertes",
    view_details: "Voir les détails",
    view_original: "Voir l'original",
    what_are_workspaces: "Qu'est-ce que les espaces de travail ?",
    workspace_created: "Espace de travail créé avec succès",
    workspace_deleted: "Espace de travail supprimé avec succès",
    workspace_name: "Nom de l'espace de travail",
    workspace_name_required: "Le nom de l'espace de travail est requis",
    workspace_updated: "Espace de travail mis à jour avec succès",
    workspaces: "Espaces de travail",
    workspaces_description:
      "Les espaces de travail vous permettent d'organiser vos projets, trackers et dashboards. Chaque espace est isolé et peut avoir ses propres paramètres et membres.",
    accountvalidation:
      "Pour activer votre compte, veuillez cliquer sur le lien ci-dessous",
    click_search_step:
      "Cliquez sur le bouton de recherche ou appuyez sur Ctrl+Entrée",
    define_categories_description:
      "Créez vos propres catégories de classification",
    doccount: "Nombre de documents",
    filtersappliedsuccess: "Filtres appliqués avec succès",
    filtersappliedfailed: "Échec de l'application des filtres",
    nochannel:
      "Aucun canal enregistré sur votre compte. Veuillez en ajouter un pour recevoir des notifications",
    search_description:
      "Sélectionnez une source et un tracker pour rechercher du contenu",
    select_tracker_step:
      "Choisissez un type de tracker (mots-clés, hashtags, etc.)",
    prev: "précédent",
    advancedoptions: "Options avancées",
    pdfquality: "Qualité PDF",
    nofilter: "Aucun filtre",
    // Plural: bulk operation messages
    n_dashboards_deleted_one: "{{count}} dashboard supprimé",
    n_dashboards_deleted_other: "{{count}} dashboards supprimés",
    n_dashboards_duplicated_one: "{{count}} dashboard dupliqué",
    n_dashboards_duplicated_other: "{{count}} dashboards dupliqués",
    n_dashboards_pinned_one: "{{count}} dashboard épinglé",
    n_dashboards_pinned_other: "{{count}} dashboards épinglés",
    n_dashboards_unpinned_one: "{{count}} dashboard désépinglé",
    n_dashboards_unpinned_other: "{{count}} dashboards désépinglés",
    n_dashboards_color_changed_one: "Couleur modifiée pour {{count}} dashboard",
    n_dashboards_color_changed_other:
      "Couleur modifiée pour {{count}} dashboards",
    n_trackers_deleted_one: "{{count}} tracker supprimé",
    n_trackers_deleted_other: "{{count}} trackers supprimés",
    n_trackers_activated_one: "{{count}} tracker activé",
    n_trackers_activated_other: "{{count}} trackers activés",
    n_trackers_deactivated_one: "{{count}} tracker désactivé",
    n_trackers_deactivated_other: "{{count}} trackers désactivés",
    n_trackers_executed_one: "{{count}} tracker exécuté",
    n_trackers_executed_other: "{{count}} trackers exécutés",
    n_trackers_tags_added_one: "Tags ajoutés à {{count}} tracker",
    n_trackers_tags_added_other: "Tags ajoutés à {{count}} trackers",
    n_enrichments_deleted_one: "{{count}} enrichissement supprimé",
    n_enrichments_deleted_other: "{{count}} enrichissements supprimés",
    n_enrichments_activated_one: "{{count}} enrichissement activé",
    n_enrichments_activated_other: "{{count}} enrichissements activés",
    n_enrichments_deactivated_one: "{{count}} enrichissement désactivé",
    n_enrichments_deactivated_other: "{{count}} enrichissements désactivés",
    n_enrichments_executed_one: "{{count}} enrichissement exécuté",
    n_enrichments_executed_other: "{{count}} enrichissements exécutés",
    n_enrichments_applied_one:
      "{{count}} enrichissement appliqué aux trackers sélectionnés",
    n_enrichments_applied_other:
      "{{count}} enrichissements appliqués aux trackers sélectionnés",
    n_alerts_deleted_one: "{{count}} alerte supprimée",
    n_alerts_deleted_other: "{{count}} alertes supprimées",
    n_alerts_activated_one: "{{count}} alerte activée",
    n_alerts_activated_other: "{{count}} alertes activées",
    n_alerts_deactivated_one: "{{count}} alerte désactivée",
    n_alerts_deactivated_other: "{{count}} alertes désactivées",
    n_alerts_executed_one: "{{count}} alerte exécutée",
    n_alerts_executed_other: "{{count}} alertes exécutées",
    n_widgets_deleted_one: "{{count}} widget supprimé",
    n_widgets_deleted_other: "{{count}} widgets supprimés",
    n_investigations_deleted_one: "{{count}} investigation supprimée",
    n_investigations_deleted_other: "{{count}} investigations supprimées",
    // Plural: error messages
    n_dashboards_delete_failed_one:
      "Échec de suppression de {{count}} dashboard",
    n_dashboards_delete_failed_other:
      "Échec de suppression de {{count}} dashboards",
    n_dashboards_duplicate_failed_one:
      "Échec de duplication de {{count}} dashboard",
    n_dashboards_duplicate_failed_other:
      "Échec de duplication de {{count}} dashboards",
    n_dashboards_color_change_failed_one:
      "Échec de changement de couleur pour {{count}} dashboard",
    n_dashboards_color_change_failed_other:
      "Échec de changement de couleur pour {{count}} dashboards",
    n_trackers_delete_failed_one: "Échec de suppression de {{count}} tracker",
    n_trackers_delete_failed_other:
      "Échec de suppression de {{count}} trackers",
    n_trackers_execute_failed_one: "Échec d'exécution de {{count}} tracker",
    n_trackers_execute_failed_other: "Échec d'exécution de {{count}} trackers",
    n_trackers_activate_failed_one: "Échec d'activation de {{count}} tracker",
    n_trackers_activate_failed_other:
      "Échec d'activation de {{count}} trackers",
    n_trackers_deactivate_failed_one:
      "Échec de désactivation de {{count}} tracker",
    n_trackers_deactivate_failed_other:
      "Échec de désactivation de {{count}} trackers",
    n_trackers_tags_failed_one:
      "Échec de mise à jour des tags pour {{count}} tracker",
    n_trackers_tags_failed_other:
      "Échec de mise à jour des tags pour {{count}} trackers",
    n_enrichments_delete_failed_one:
      "Échec de suppression de {{count}} enrichissement",
    n_enrichments_delete_failed_other:
      "Échec de suppression de {{count}} enrichissements",
    n_enrichments_execute_failed_one:
      "Échec d'exécution de {{count}} enrichissement",
    n_enrichments_execute_failed_other:
      "Échec d'exécution de {{count}} enrichissements",
    n_enrichments_activate_failed_one:
      "Échec d'activation de {{count}} enrichissement",
    n_enrichments_activate_failed_other:
      "Échec d'activation de {{count}} enrichissements",
    n_enrichments_deactivate_failed_one:
      "Échec de désactivation de {{count}} enrichissement",
    n_enrichments_deactivate_failed_other:
      "Échec de désactivation de {{count}} enrichissements",
    n_alerts_delete_failed_one: "Échec de suppression de {{count}} alerte",
    n_alerts_delete_failed_other: "Échec de suppression de {{count}} alertes",
    n_alerts_activate_failed_one: "Échec d'activation de {{count}} alerte",
    n_alerts_activate_failed_other: "Échec d'activation de {{count}} alertes",
    n_alerts_deactivate_failed_one:
      "Échec de désactivation de {{count}} alerte",
    n_alerts_deactivate_failed_other:
      "Échec de désactivation de {{count}} alertes",
    n_alerts_execute_failed_one: "Échec d'exécution de {{count}} alerte",
    n_alerts_execute_failed_other: "Échec d'exécution de {{count}} alertes",
    n_widgets_delete_failed_one: "Échec de suppression de {{count}} widget",
    n_widgets_delete_failed_other: "Échec de suppression de {{count}} widgets",
    n_investigations_delete_failed_one:
      "Échec de suppression de {{count}} investigation",
    n_investigations_delete_failed_other:
      "Échec de suppression de {{count}} investigations",
    // Plural: progress messages
    deleting_n_trackers_one: "Suppression de {{count}} tracker…",
    deleting_n_trackers_other: "Suppression de {{count}} trackers…",
    executing_n_trackers_one: "Exécution de {{count}} tracker…",
    executing_n_trackers_other: "Exécution de {{count}} trackers…",
    activating_n_trackers_one: "Activation de {{count}} tracker…",
    activating_n_trackers_other: "Activation de {{count}} trackers…",
    deactivating_n_trackers_one: "Désactivation de {{count}} tracker…",
    deactivating_n_trackers_other: "Désactivation de {{count}} trackers…",
    adding_tags_n_trackers_one: "Ajout de tags à {{count}} tracker…",
    adding_tags_n_trackers_other: "Ajout de tags à {{count}} trackers…",
    executing_n_enrichments_one: "Exécution de {{count}} enrichissement…",
    executing_n_enrichments_other: "Exécution de {{count}} enrichissements…",
    activating_n_enrichments_one: "Activation de {{count}} enrichissement…",
    activating_n_enrichments_other: "Activation de {{count}} enrichissements…",
    deactivating_n_enrichments_one:
      "Désactivation de {{count}} enrichissement…",
    deactivating_n_enrichments_other:
      "Désactivation de {{count}} enrichissements…",
    // Plural: UI display messages
    n_sources_one: "{{count}} source",
    n_sources_other: "{{count}} sources",
    n_trackers_count_one: "{{count}} tracker",
    n_trackers_count_other: "{{count}} trackers",
    n_documents_one: "{{count}} document",
    n_documents_other: "{{count}} documents",
    n_documents_found_one: "{{count}} document trouvé",
    n_documents_found_other: "{{count}} documents trouvés",
    n_documents_loaded_one: "{{count}} document chargé",
    n_documents_loaded_other: "{{count}} documents chargés",
    n_documents_imported_one: "{{count}} document importé avec succès",
    n_documents_imported_other: "{{count}} documents importés avec succès",
    n_documents_ready_one: "{{count}} document prêt à être importé",
    n_documents_ready_other: "{{count}} documents prêts à être importés",
    n_selected_one: "{{count}} sélectionné",
    n_selected_other: "{{count}} sélectionnés",
    n_trackers_selected_one: "{{count}} tracker sélectionné",
    n_trackers_selected_other: "{{count}} trackers sélectionnés",
    n_rows_one: "{{count}} ligne",
    n_rows_other: "{{count}} lignes",
    n_elements_one: "{{count}} élément",
    n_elements_other: "{{count}} éléments",
    n_properties_one: "Objet avec {{count}} propriété",
    n_properties_other: "Objet avec {{count}} propriétés",
    n_branches_one: "{{count}} branche",
    n_branches_other: "{{count}} branches",
    n_commits_one: "{{count}} commit",
    n_commits_other: "{{count}} commits",
    n_executions_found_one: "{{count}} exécution trouvée",
    n_executions_found_other: "{{count}} exécutions trouvées",
    n_queries_configured_one: "{{count}} requête configurée",
    n_queries_configured_other: "{{count}} requêtes configurées",
    n_values_one: "{{count}} valeur",
    n_values_other: "{{count}} valeurs",
    n_operations_applied_one: "Merge réussi : {{count}} opération appliquée",
    n_operations_applied_other:
      "Merge réussi : {{count}} opérations appliquées",
    n_operations_skipped_one: "{{count}} opération ignorée (conflits)",
    n_operations_skipped_other: "{{count}} opérations ignorées (conflits)",
    n_investigations_will_be_deleted_one:
      "{{count}} investigation sera supprimée.",
    n_investigations_will_be_deleted_other:
      "{{count}} investigations seront supprimées.",
    n_dashboards_will_be_deleted_one: "{{count}} dashboard sera supprimé.",
    n_dashboards_will_be_deleted_other:
      "{{count}} dashboards seront supprimés.",
    import_n_documents_one: "Importer {{count}} document",
    import_n_documents_other: "Importer {{count}} documents",
    tab_created_with_n_widgets_one:
      'L\'onglet "{{name}}" a été créé avec {{count}} widget.',
    tab_created_with_n_widgets_other:
      'L\'onglet "{{name}}" a été créé avec {{count}} widgets.',
    n_widgets_one: "{{count}} widget",
    n_widgets_other: "{{count}} widgets",
    execution_completed_n_new_documents_one:
      "Exécution terminée — {{count}} nouveau document",
    execution_completed_n_new_documents_other:
      "Exécution terminée — {{count}} nouveaux documents",
    enrichment_completed_n_documents_one:
      "Enrichissement terminé — {{count}} document enrichi",
    enrichment_completed_n_documents_other:
      "Enrichissement terminé — {{count}} documents enrichis",
    n_documents_deleted_one: "{{count}} document supprimé",
    n_documents_deleted_other: "{{count}} documents supprimés",
    see_n_more_documents_one: "Voir {{count}} document de plus",
    see_n_more_documents_other: "Voir {{count}} documents de plus",
    n_active_filters_one: "{{count}} filtre actif",
    n_active_filters_other: "{{count}} filtres actifs",
    validate_n_selected_one: "Valider ({{count}} sélectionné)",
    validate_n_selected_other: "Valider ({{count}} sélectionnés)",
    n_enrichments_to_apply_one: "{{count}} enrichissement à appliquer",
    n_enrichments_to_apply_other: "{{count}} enrichissements à appliquer",
    n_of_total_selected_one: "{{count}} / {{total}} sélectionné",
    n_of_total_selected_other: "{{count}} / {{total}} sélectionnés",
    n_of_total_trackers_selected_one:
      "{{count}} / {{total}} tracker sélectionné",
    n_of_total_trackers_selected_other:
      "{{count}} / {{total}} trackers sélectionnés",
    n_sources_available_one: "{{count}}/{{total}} source",
    n_sources_available_other: "{{count}}/{{total}} sources",
    n_tags_selected_one: "{{count}} tag sélectionné",
    n_tags_selected_other: "{{count}} tags sélectionnés",
    n_custom_params_one: "{{count}} paramètre personnalisé",
    n_custom_params_other: "{{count}} paramètres personnalisés",
    // Plural: execution status labels
    n_success_one: "{{count}} succès",
    n_success_other: "{{count}} succès",
    n_errors_one: "{{count}} erreur",
    n_errors_other: "{{count}} erreurs",
    n_running_one: "{{count}} en cours",
    n_running_other: "{{count}} en cours",
    success_rate: "{{rate}}% succès",
    error_rate: "{{rate}}% erreurs",
    // Plural: noun-only labels (for stat cards / tabs where the count is displayed separately)
    execution_label_one: "Exécution",
    execution_label_other: "Exécutions",
    document_label_one: "Document",
    document_label_other: "Documents",
  },
};
